<template>
  <a-modal
    title="编辑医生服务审核1"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
        <a-form-item
          label="用户id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入用户id" v-decorator="['userId', {rules: [{required: true, message: '请输入用户id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医院"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医院" v-decorator="['orgId', {rules: [{required: true, message: '请输入医院！'}]}]" />
        </a-form-item>
        <a-form-item
          label="科室"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入科室" v-decorator="['deptId', {rules: [{required: true, message: '请输入科室！'}]}]" />
        </a-form-item>
        <a-form-item
          label="性别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入性别" v-decorator="['sex', {rules: [{required: true, message: '请输入性别！'}]}]" />
        </a-form-item>
        <a-form-item
          label="出生日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择出生日期" v-decorator="['birthday',{rules: [{ required: true, message: '请选择出生日期！' }]}]" @change="onChangebirthday"/>
        </a-form-item>
        <a-form-item
          label="职称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入职称" v-decorator="['protitle', {rules: [{required: true, message: '请输入职称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="电话"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入电话" v-decorator="['phone', {rules: [{required: true, message: '请输入电话！'}]}]" />
        </a-form-item>
        <a-form-item
          label="身份证号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入身份证号" v-decorator="['cardNo', {rules: [{required: true, message: '请输入身份证号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医生简介"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医生简介" v-decorator="['content', {rules: [{required: true, message: '请输入医生简介！'}]}]" />
        </a-form-item>
        <a-form-item
          label="服务类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入服务类型" v-decorator="['expertIn', {rules: [{required: true, message: '请输入服务类型！'}]}]" />
        </a-form-item>
        <a-form-item
          label="顺序号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入顺序号" v-decorator="['orderNo', {rules: [{required: true, message: '请输入顺序号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="创建时间戳"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择创建时间戳" v-decorator="['ctstamp',{rules: [{ required: true, message: '请选择创建时间戳！' }]}]" @change="onChangectstamp"/>
        </a-form-item>
        <a-form-item
          label="更新时间戳"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        </a-form-item>
        <a-form-item
          label="是否删除（0否，1是）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入是否删除（0否，1是）" v-decorator="['delflag', {rules: [{required: true, message: '请输入是否删除（0否，1是）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入姓名" v-decorator="['name', {rules: [{required: true, message: '请输入姓名！'}]}]" />
        </a-form-item>
        <a-form-item
          label="角色"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入角色" v-decorator="['type', {rules: [{required: true, message: '请输入角色！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baDoctorServiceCheckEdit } from '@/api/modular/interhospital/badoctorservicecheck/baDoctorServiceCheckManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        birthdayDateString: '',
        ctstampDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              id: record.id,
              userId: record.userId,
              orgId: record.orgId,
              deptId: record.deptId,
              sex: record.sex,
              protitle: record.protitle,
              phone: record.phone,
              cardNo: record.cardNo,
              content: record.content,
              expertIn: record.expertIn,
              orderNo: record.orderNo,
              utstamp: record.utstamp,
              delflag: record.delflag,
              name: record.name,
              type: record.type
            }
          )
        }, 100)
        // 时间单独处理
        if (record.birthday != null) {
            this.form.getFieldDecorator('birthday', { initialValue: moment(record.birthday, 'YYYY-MM-DD') })
        }
        this.birthdayDateString = moment(record.birthday).format('YYYY-MM-DD')
        // 时间单独处理
        if (record.ctstamp != null) {
            this.form.getFieldDecorator('ctstamp', { initialValue: moment(record.ctstamp, 'YYYY-MM-DD') })
        }
        this.ctstampDateString = moment(record.ctstamp).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.birthday = this.birthdayDateString
            values.ctstamp = this.ctstampDateString
            baDoctorServiceCheckEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
